module.exports = __webpack_public_path__ + "img/tikgestion.74d9b6f4.svg";